'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:staffScheduleController
 * @description
 * # staffScheduleController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('staffSchedulingController', ['$scope', '$uibModalInstance', 'data', 'ConfirmationService', 'DailyPlanService', 'FlashService', 'Constants', 'ElementIdHelper',
      function ($scope, $uibModalInstance, data, ConfirmationService, DailyPlanService, FlashService, Constants, ElementIdHelper) {

          $scope.dateDisplayed = moment(data.dateDisplayed).format('dddd MMMM DD, YYYY');
          $scope.isCurrentDateDisplayed = data.isCurrentDateDisplayed;
          $scope.isPastDateDisplayed = data.isPastDateDisplayed;
          $scope.isFutureDateDisplayed = data.isFutureDateDisplayed;
          $scope.activityType = Constants.ActivityTypes;
          $scope.staffNoteEditingIsOpened = false;

          function initData() {

              $scope.selectActivityAction(null);

              var request = {
                  personId: data.personId,
                  date: data.dateDisplayed
              };

              $scope.loading = true;
              DailyPlanService.LoadStaffActivities(request).then(function (result) {

                  if (result.success) {
                      $scope.staffContacts = result.data.staffContacts;
                      $scope.activityStatuses = data.activityStatuses;
                      $scope.groupsWithoutCancelledActivities = groupActivities(result.data.staffSchedules.filter(function (activity) { return activity.statusId !== Constants.ActivityStatus.Cancelled; }) || []);
                      $scope.cancelledActivitiesGroups = groupActivities(result.data.staffSchedules.filter(function (activity) { return activity.statusId === Constants.ActivityStatus.Cancelled; }) || []);
                      $scope.groups = $scope.groupsWithoutCancelledActivities;

                      $scope.cancelledActivitiesCount = result.data.staffSchedules.filter(function (activity) { return activity.statusId === Constants.ActivityStatus.Cancelled; }).length;

                      setPossibleActivityActions();

                      $scope.dialogTitle = "{0}’s schedule".format(result.data.staffContacts.fullName);
                  }

                  $scope.loading = false;
              });
          }

          function groupActivities(activities) {

              var groupByGroupName = activities.groupBy('groupName');

              

              groupByGroupName.forEach(function (group) {

                  group.expanded = true;
                  group.isCategoryRoomActivities = Math.max.apply(Math, group.items.map(function (o) { return o.category; })) === 1;

                  group.hasNotStartedActivities = group.items.filter(function (o) { return o.statusId === Constants.ActivityStatus.NotStarted; }).length > 0;

                  group.isCategoryStaffActivities = Math.max.apply(Math, group.items.map(function (o) { return o.category; })) === 4;

                  var byLocate = group.items.groupBy('locate');

                  byLocate.forEach(function (byLocateGroup) {
                      byLocateGroup.expanded = true;
                      byLocateGroup.icons = getUniqueIcons(byLocateGroup.items);

                      byLocateGroup.items.forEach(function (activity) {
                          activity.elementClassName = ElementIdHelper.getActivityElementClassName(activity.scheduleId, activity.statusId);
                      });

                      byLocateGroup.hasNotStartedActivities = byLocateGroup.items.filter(function (o) { return o.statusId === Constants.ActivityStatus.NotStarted; }).length > 0;

                      var byLocateGroupStatus = byLocateGroup.items.groupBy('status');

                      if (data.isPastDateDisplayed()) {

                          if (byLocateGroupStatus.length > 1) {
                              byLocateGroup.status = $scope.activityStatuses[4].value;
                              byLocateGroup.statusIcon = $scope.activityStatuses[4].icon;
                          } else {

                              if (byLocateGroupStatus[0].key === $scope.activityStatuses[2].value) {
                                  byLocateGroup.statusIcon = $scope.activityStatuses[2].icon;
                                  byLocateGroup.status = $scope.activityStatuses[2].value;
                              } else {
                                  byLocateGroup.status = $scope.activityStatuses[4].value;
                                  byLocateGroup.statusIcon = $scope.activityStatuses[4].icon;
                              }
                          }
                      } else {

                          if (byLocateGroupStatus.length > 1) {
                              byLocateGroup.status = $scope.activityStatuses[1].value;
                              byLocateGroup.statusIcon = $scope.activityStatuses[1].icon;
                          } else {

                              if (byLocateGroupStatus[0].key === $scope.activityStatuses[0].value) {
                                  byLocateGroup.statusIcon = $scope.activityStatuses[0].icon;
                              } else if (byLocateGroupStatus[0].key === $scope.activityStatuses[2].value) {
                                  byLocateGroup.statusIcon = $scope.activityStatuses[2].icon;
                              } else {
                                  group.statusIcon = group.items[0].statusIcon;
                              }

                              byLocateGroup.status = byLocateGroupStatus[0].key;
                          }
                      }
                  });

                  var byGroupStatus = group.items.groupBy('status');

                  if (data.isPastDateDisplayed()) {

                      if (byGroupStatus.length > 1) {
                          group.status = $scope.activityStatuses[4].value;
                          group.statusIcon = $scope.activityStatuses[4].icon;
                      } else {

                          if (byGroupStatus[0].key === $scope.activityStatuses[2].value) {
                              group.statusIcon = $scope.activityStatuses[2].icon;
                              group.status = $scope.activityStatuses[2].value;
                          } else {
                              group.status = $scope.activityStatuses[4].value;
                              group.statusIcon = $scope.activityStatuses[4].icon;
                          }
                      }
                  } else {

                      if (byGroupStatus.length > 1) {
                          group.status = $scope.activityStatuses[1].value;
                          group.statusIcon = $scope.activityStatuses[1].icon;
                      } else {
                          if (byGroupStatus[0].key === $scope.activityStatuses[0].value) {
                              group.statusIcon = $scope.activityStatuses[0].icon;
                          } else if (byGroupStatus[0].key === $scope.activityStatuses[2].value) {
                              group.statusIcon = $scope.activityStatuses[2].icon;
                          } else {
                              group.statusIcon = group.items[0].statusIcon;
                          }

                          group.status = byGroupStatus[0].key;
                      }
                  }

                  group.items = byLocate;
                  group.icons = getUniqueIcons(getAllActivities(group));

                  if (group.items.length > 0) {
                      group.items.forEach(function () {
                          var qcGroup = group.items.filter(obj => {
                              return obj.key === "QC Check Activities";
                          });
                          if (qcGroup.length > 0) {
                              qcGroup.forEach(function (qc) {
                                  group.items.push(group.items.splice(group.items.indexOf(qc), 1)[0]);
                              });
                          }

                      });
                  }
              });

              return groupByGroupName;
          }

          $scope.orderRoomActivitiesFilter = function (value) {

              if (value.key === 'Room Activities') {
                  return true;
              }
              else {
                  return false;
              }
          };

          $scope.showCheckbox = function (group, item) {
              var show = true;

              switch ($scope.selectedActivityAction.id) {
                  case -10:
                      return !group.isCategoryStaffActivities;
                  case 1:
                      return item ? item.statusId !== 1 : group.status !== 'Not Started';
                  case 3:
                      return item ? item.statusId !== 3 : group.status !== 'Completed';
              }

              return show;

          };

          $scope.getMessage = function () {
              switch ($scope.selectedActivityAction.id) {
                  case -10:
                      return 'Cannot un-assign';
                  default:
                      return 'Already {0}'.format($scope.selectedActivityAction.value);
              }
          };

          $scope.expandAllGroupsAndItems = function () {
              $scope.groups.forEach(function (group) {
                  group.items.forEach(function (locateGroup) {
                      locateGroup.expanded = true;
                  });

                  group.expanded = true;
              });
          };

          $scope.collapseAllGroupsAndItems = function () {
              $scope.groups.forEach(function (group) {
                  group.items.forEach(function (locateGroup) {
                      locateGroup.expanded = false;
                  });

                  group.expanded = false;
              });
          };

          $scope.updateStaff = function () {

              var updateAction = function () {

                  var toUpdate = getActivitiesToUpdate();

                  var facilityGroup = toUpdate.groupBy(function (activity) {
                      return activity.facilityCode;
                  });

                  var dailySocketVM = {};
                  dailySocketVM.Date = data.dateDisplayed;
                  dailySocketVM.DailySocketFacilities = [];

                  facilityGroup.forEach(function (group) {
                      var groupTmpl = {};

                      groupTmpl.FacilityCode = group.key;
                      groupTmpl.Rooms = group.items.map(function (activity) {
                          return activity.roomNumber;
                      }).unique();
                      dailySocketVM.DailySocketFacilities.push(groupTmpl);

                  });

                  var request = {
                      actionId: $scope.selectedActivityAction.id,
                      scheduleIds: toUpdate.map(function (activity) {
                          return activity.scheduleId;
                      }),
                      dailySocketVM: dailySocketVM
                  };

                  var loading = FlashService.Loading();
                  DailyPlanService.UpdateStaff(request).then(function (result) {

                      if (result.success) {
                          if ($scope.selectedActivityAction.value === "Un-assign") {
                              FlashService.Success('{0} successfully un-assigned from checked activities.'.format($scope.staffContacts.fullName));
                          }
                          else {
                              FlashService.Success('Checked activities successfully marked {0}.'.format($scope.selectedActivityAction.value));
                          }
                          initData();
                          data.reloadCallback();
                      }

                      loading.dismiss();
                  });
              };

              var confirmation = getConfirmationData();

              ConfirmationService.YesNoConfirmation(confirmation.message,
                                                            null,
                                                            {
                                                                title: confirmation.title,
                                                                no: 'Never mind',
                                                                yes: confirmation.button
                                                            })
                                         .Yes(updateAction)
                                         .Ask();

          };

          $scope.noActivitiesToUpdate = function () {

              return !$scope.groups.some(function (group) {
                  return group.update || group.items.some(function (byLocate) {
                      return byLocate.update || byLocate.items.some(function (activity) {
                          return activity.update;
                      });
                  });
              });
          };

          $scope.showCancelledActivities = function () {
              $scope.cancelledActivitiesAreDisplayed = true;
              $scope.groups = $scope.cancelledActivitiesGroups;

              if (data.isPastDateDisplayed()) {
                  $scope.selectActivityAction($scope.possibleActivityActions.filter(function (activityStatusItem) { return activityStatusItem.id === 5; })[0]);
              } else {
                  $scope.selectActivityAction($scope.possibleActivityActions.filter(function (activityStatusItem) { return activityStatusItem.id === 1; })[0]);
              }
          };

          $scope.selectActivityAction = function (selectedAction) {
              if ($scope.cancelledActivitiesAreDisplayed && selectedAction === null) {
                  $scope.cancelledActivitiesAreDisplayed = false;
                  $scope.groups = $scope.groupsWithoutCancelledActivities;
              }

              if ($scope.groups && selectedAction === null) {
                  $scope.groups.forEach(group => {
                      group.update = false;
                      group.items.forEach(byLocate => {
                          byLocate.update = false;
                          (byLocate.items || []).forEach(item => item.update = false);
                      });
                  });
              }

              $scope.selectedActivityAction = selectedAction;
          };

          function getActivitiesToUpdate() {

              var result = [];

              $scope.groups.forEach(function (group) {
                  group.items.forEach(function (byLocate) {
                      byLocate.items.forEach(function (activity) {

                          if (activity.update && activity.statusId !== $scope.selectedActivityAction.id) {
                              result.push(activity);
                          }
                      });
                  });

              });

              return result;
          }

          $scope.onGroupUpdateChanged = function (group) {

              group.items.forEach(function (byLocate) {
                  byLocate.update = group.update;
                  byLocate.items.forEach(function (activity) {
                      activity.update = byLocate.update;
                  });
              });
          };

          $scope.onLocateUpdateChanged = function (byLocate, group) {

              byLocate.items.forEach(function (activity) {
                  activity.update = byLocate.update;
              });

              updateParentUpdateState(group);
          };

          $scope.onActivityUpdateChanged = function (activity, byLocate, group) {
              updateParentUpdateState(byLocate);
              updateParentUpdateState(group);
          };

          $scope.totalDurationSum = function () {
              return $scope.groups.sumOf('totalDuration');
          };

          $scope.markedToUpdate = function () {

              var result = 0;

              $scope.groups.forEach(function (group) {
                  group.items.forEach(function (byLocate) {
                      byLocate.items.forEach(function (activity) {

                          if (activity.update && activity.statusId !== $scope.selectedActivityAction.id) {
                              result += 1;
                          }

                      });
                  });
              });

              return result;
          };

          $scope.openStaffNoteEditing = function (activityItem) {
              $scope.selectedActivityItemForNote = activityItem;

              $scope.activityNoteText = $scope.selectedActivityItemForNote.activityNotes;

              $scope.staffNoteEditingIsOpened = true;
          };

          $scope.closeStaffNoteEditing = function () {
              $scope.selectedActivityItemForNote = null;

              $scope.activityNoteText = '';

              $scope.staffNoteEditingIsOpened = false;
          };

          $scope.updateStaffNote = function () {

              var request = {
                  scheduleID: $scope.selectedActivityItemForNote.scheduleId,
                  notes: $scope.activityNoteText,
                  action: Constants.DBActions.Update,
              };

              var loading = FlashService.Loading();
              DailyPlanService.EditStaffNotes(request).then(function (result) {

                  if (result.success) {
                      FlashService.Success('Staff notes have been updated.');

                      $scope.selectedActivityItemForNote.activityNotes = $scope.activityNoteText;

                      data.reloadCallback();

                      $scope.closeStaffNoteEditing();
                  }

                  loading.dismiss();
              });
          };

          function setPossibleActivityActions() {
              $scope.possibleActivityActions = [];

              $scope.possibleActivityActions.push(angular.copy(($scope.activityStatuses.filter(function (activityStatusItem) { return activityStatusItem.id === 4; }))[0]));
              
              $scope.possibleActivityActions.push(angular.copy(($scope.activityStatuses.filter(function (activityStatusItem) { return activityStatusItem.id === 3; }))[0]));
              $scope.possibleActivityActions[$scope.possibleActivityActions.length - 1].hideOnFutureDays = true;
              $scope.possibleActivityActions.push(angular.copy(($scope.activityStatuses.filter(function (activityStatusItem) { return activityStatusItem.id === 1; }))[0]));
              $scope.possibleActivityActions[$scope.possibleActivityActions.length - 1].hideOnPastDays = true;
              $scope.possibleActivityActions[$scope.possibleActivityActions.length - 1].hideOnFutureDays = true;
              $scope.possibleActivityActions.push(angular.copy(($scope.activityStatuses.filter(function (activityStatusItem) { return activityStatusItem.id === 5; }))[0]));
              $scope.possibleActivityActions[$scope.possibleActivityActions.length - 1].hideOnCurrentDay = true;
              $scope.possibleActivityActions[$scope.possibleActivityActions.length - 1].hideOnFutureDays = true;
          }

          function updateParentUpdateState(parent) {

              parent.update = parent.items.every(function (item) {
                  return item.update;
              });
          }

          function getUniqueIcons(activities) {

              var icons = activities.filter(function (activity) {
                  return activity.activityIcon;
              }).map(function (activity) {
                  return {
                      icon: Constants.ActivityTypes.getIconSrc(activity),
                      color: Constants.ActivityTypes.getIconColor(activity.activityIcon)
                  };
              }).unique(function (icon1, icon2) {
                  return icon1.icon === icon2.icon &&
                         icon1.color === icon2.color;
              });

              return icons;
          }

          function getAllActivities(group) {

              var result = [];

              group.items.forEach(function (byLocate) {
                  byLocate.items.forEach(function (activity) {
                      result.push(activity);
                  });
              });

              return result;
          }

          function getConfirmationData() {
              return {
                  title: $scope.selectedActivityAction.id === -10 ? 'Un-assign Staff from Activities' : 'Mark checked activities {0}'.format($scope.selectedActivityAction.value),
                  message: $scope.selectedActivityAction.id === -10 ? 'Are you sure you want to un-assign this staff from all checked activities?   ' : 'Are you sure you want to mark checked activities {0}?'.format($scope.selectedActivityAction.value),
                  button: $scope.selectedActivityAction.id === -10 ? 'Yes, un-assign staff from checked activities' : 'Yes, mark checked activities {0}'.format($scope.selectedActivityAction.value)
              };
          }

          $scope.close = function (closeType) {
              $uibModalInstance.close(closeType || false);
          };

          $scope.dismiss = function () {
              $uibModalInstance.dismiss();
          };


          initData();

      }]);
